import { render } from "./PricingModals.vue?vue&type=template&id=283b4dae&scoped=true"
import script from "./PricingModals.vue?vue&type=script&lang=js"
export * from "./PricingModals.vue?vue&type=script&lang=js"

import "./PricingModals.vue?vue&type=style&index=0&id=283b4dae&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283b4dae"]])

export default __exports__